import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { IonSkeletonText, IonLabel } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';

import { ContactProfileComponent } from '../contact-profile/contact-profile.component';

export interface ContactDisplay {
  id: string;
  alias: string;
  role?: string;
}

@Component({
  selector: 'lib-contacts-avatars',
  standalone: true,
  imports: [CommonModule, IonSkeletonText, IonLabel, ContactProfileComponent, TranslocoPipe],
  templateUrl: './contacts-avatars.component.html',
  styleUrl: './contacts-avatars.component.scss',
})
export class ContactsAvatarsComponent {
  // inputs
  contacts = input<Array<ContactDisplay>>([]);
  loading = input<boolean>(false);
  maxDisplayed = input<number>(4);
  showRole = input<boolean>(false);

  // computed
  protected readonly displayedContacts$$ = computed(() => {
    const contacts = this.contacts();
    const max = this.maxDisplayed();
    return contacts.length > max ? contacts.slice(0, max - 1) : contacts;
  });

  protected readonly remainingCount$$ = computed(() => {
    const total = this.contacts().length;
    const max = this.maxDisplayed();
    return total > max ? total - (max - 1) : 0;
  });

  protected readonly hasContacts$$ = computed(() => this.contacts().length > 0);
}
